'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('react-dates/initialize');
require('react-dates/lib/css/_datepicker.css');
var DayElement = require('../components/DayElement/DayElement.js');
var moment = _interopDefault(require('moment'));
var styledComponents = require('./styled-components.js');

var DatePicker = function (props) {
    var _a = props.placeholder, placeholder = _a === void 0 ? 'Select a delivery date' : _a, title = props.title, reporter = props.reporter, _b = props.style, style = _b === void 0 ? {} : _b, defaultDate = props.defaultDate, _c = props.disableFuture, disableFuture = _c === void 0 ? false : _c, _d = props.disablePast, disablePast = _d === void 0 ? false : _d, maxDate = props.maxDate, minDate = props.minDate, clearValue = props.clearValue, disabled = props.disabled, autoOk = props.autoOk, reportError = props.reportError;
    var _e = React.useState(defaultDate ? moment(defaultDate) : null), date = _e[0], setDate = _e[1];
    var onDateChange = function (e) {
        if (reporter)
            reporter(e);
        setDate(e);
    };
    var onError = function (error) {
        if (reportError)
            reportError(error);
    };
    React.useEffect(function () {
        if (clearValue) {
            setDate(null);
        }
    }, [clearValue]);
    return (React__default.createElement(styledComponents.Wrapper, null,
        title && React__default.createElement(styledComponents.StyledInputLabel, null, title),
        React__default.createElement(styledComponents.StyledInput, { style: style, disableToolbar: true, variant: 'inline', format: 'MM/DD/YYYY', placeholder: placeholder, value: date, onChange: onDateChange, KeyboardButtonProps: {
                'aria-label': 'change date',
            }, renderDay: DayElement, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, inputVariant: 'outlined', disabled: disabled, autoOk: autoOk, onError: function (error) {
                onError(String(error));
            } })));
};

module.exports = DatePicker;
